<template>
	<v-container>
		<common-table
			:headers="headers"
			:items="items"
			:items-length="pagination.totalItemCount"
			:options.sync="tableOptions"
			:loading="loading"
			:items-per-page-options="tableFooterProps.itemsPerPageOptions"
			:entity-name="$t('proforma_invoice')"
			:button-text="buttonText"
			@row-click="rowAction"
			@button-click="handleButtonClick"
			:disable-sort="false"
		>
			<template #item.date="{ item }">
				{{ item.date ? item.date.format($t("$format.date")) : "" }}
			</template>
			<template #item.status="{ item }">
				<v-chip
					:ripple="false"
					:color="getProformaChipColor(item.status)"
					:text-color="getProformaChipTextColor(item.status)"
				>
					{{ $t(`$proformaInvoice.$status.${item.status}`) }}
				</v-chip>
			</template>
		</common-table>
	</v-container>
</template>

<script>
import {
	pagination as paginationMixin,
	getProformaChipColor,
	getProformaChipTextColor,
} from "../../../mixins/utils.mixin";
import remote from "../../../../data/remote";
import CommonTable from "../../../partials/CommonTable.vue";

export default {
	props: {
		role: "sender" | "receiver",
		filterData: Object,
		initialPage: Number,
		atFront: Boolean,
		listChanged: Boolean,
		buttonText: String,
	},
	mixins: [paginationMixin],
	components: {
		CommonTable,
	},
	data() {
		return {
			items: [],
			loading: true,
			lastFilter: {},
			outgoingHeaders: [
				{ text: this.$t("proforma_number"), value: "no" },
				{ text: this.$t("receiver"), value: "receiver.name" },
				{ text: this.$t("date"), value: "date" },
				{ text: this.$t("status"), value: "status" },
			],
			incomingHeaders: [
				{ text: this.$t("proforma_number"), value: "no" },
				{ text: this.$t("sender"), value: "sender.name" },
				{ text: this.$t("date"), value: "date" },
				{ text: this.$t("status"), value: "status" },
			],
		};
	},
	computed: {
		oppositeRole() {
			return this.role == "sender" ? "receiver" : "sender";
		},
		headers() {
			return this.role == "sender" ? this.outgoingHeaders : this.incomingHeaders;
		},
	},
	watch: {
		tableOptions: {
			handler(newOptions, oldOptions) {
				this.loadItems();
			},
			deep: true,
		},
		filterData(val) {
			if (JSON.stringify(val) != JSON.stringify(this.lastFilter)) {
				this.lastFilter = val;
				this.loadItems();
			}
		},
		atFront(val) {
			if (val) {
				let query = Object.assign({}, this.$route.query);
				if (this.tableOptions.page != query.page) {
					query.page = this.tableOptions.page;
					this.$router.replace({ query });
				}
			}
		},
		listChanged() {
			this.loadItems();
		},
	},
	methods: {
		getProformaChipColor,
		getProformaChipTextColor,
		loadItems() {
			this.loading = true;

			const query = Object.assign({}, this.$route.query);
			if (query.page != this.tableOptions.page) query.page = this.tableOptions.page;
			query.referenceId = this.filterData.referenceId || undefined;
			query.statuses = this.filterData.statuses.length ? this.filterData.statuses.join() : undefined;
			if (JSON.stringify(query) != JSON.stringify(this.$route.query)) this.$router.replace({ query });

			remote.proformaInvoices.filter(
				{
					filter: this.filterData,
					pager: {
						number: this.tableOptions.page,
						size: this.tableOptions.itemsPerPage,
					},
					sorter:
						this.tableOptions.sortBy.length && this.tableOptions.sortBy[0]
							? {
									property: this.tableOptions.sortBy[0],
									method: this.tableOptions.sortDesc[0] ? "desc" : "asc",
							  }
							: undefined,
				},
				{
					onSuccess: (result) => {
						this.items = result.items;
						this.pagination = result.pagination;
						this.loading = false;
					},
					onFail: (_) => {
						this.loading = false;
					},
				}
			);
		},

		rowAction(item) {
			this.$emit("rowAction", item);
		},
		handleButtonClick() {
			this.$emit("buttonClick");
		},
	},
	created() {
		if (this.initialPage) this.tableOptions.page = this.initialPage;
		this.loadItems();
	},
};
</script>
